import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "checkout",
  "use": "checkout-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"checkout\"><path d=\"M8.502 5c-.257-1.675.04-3.562 1.229-5h7.259c-.522.736-1.768 2.175-1.391 5h-1.154c-.147-1.336.066-2.853.562-4h-4.725c-.666 1.003-.891 2.785-.657 4H8.502zM19 4v20H5V4h2.374v.675C7.374 5.407 7.957 6 8.676 6h6.647c.721 0 1.304-.593 1.304-1.325V4H19zm-9 17H8v1h2v-1zm0-2H8v1h2v-1zm0-2H8v1h2v-1zm3 4h-2v1h2v-1zm0-2h-2v1h2v-1zm0-2h-2v1h2v-1zm3 4h-2v1h2v-1zm0-2h-2v1h2v-1zm0-2h-2v1h2v-1zm-6-2H8v1h2v-1zm3 0h-2v1h2v-1zm3 0h-2v1h2v-1zm1-7H7v5h10V8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/checkout.svg
// module id = /m7D
// module chunks = 1